import { toast } from "react-hot-toast"
import Communication from "../../communication"
import config from "../../config"
import TokensService from "../token/service"

const DashboardsService = { 
    loadDashboards(dispatch, data) {
        dispatch({
            type: 'LOAD_DASHBOARDS',
            payload: null
        })
        Communication.getMethod(
            config.endPoints.dashboards,
            {}
        ).then(dashboards => { 
                dispatch({
                    type: 'GET_DASHBOARDS',
                    payload: dashboards
                })
        }).catch(() => {
            dispatch({
                type: 'ERROR_DASHBOARDS',
                payload: null
            })
        }).finally(() => {})
    },
    makeAction(dispatch, data) {
        Communication.postMethod(
            config.endPoints.action,
            {action: data.action, items: data.items, dashboard: data.dashboard, des_dashboard: data?.des_dashboard}
        ).then(dashboards => { 
            DashboardsService.loadDashboards(dispatch, {});
            TokensService.loadDashboards(dispatch, {});
        }).catch(() => {
            
        }).finally(() => {})
    },
    analysis(data) {
        Communication.postMethod(
            config.endPoints.analysis,
            {contract: data.id, price: data.price, low_price: data.low_price, high_price: data.high_price, high_details: data?.high_details, low_details: data?.low_details}
        ).then(data => { 
            return data
        }).catch(() => {
            return false
        }).finally(() => {})
    },
    holder(data) {
        Communication.postMethod(
            config.endPoints.holder,
            {address: data.address}
        ).then(data => { 
            return data
        }).catch(() => {
            return false
        }).finally(() => {})
    },
    addToken(dispatch, data) {
        Communication.postMethod(
            config.endPoints.add_token,
            {contract: data}
        ).then(data => { 
            return data
        }).catch(() => {
            return false
        }).finally(() => {})
    },
    
}
export default DashboardsService;